import React from "react";
import { User } from "../../Store/models/User";
import LargePlusLogo from "./LargePlusLogo";
interface PlusEssentialsPhase1AdProps {
  backgroundImage: string;
  campaignEndDate: string;
  couponCode: string;
  dollarAmountSaved: number;
  link: string;
  mobileBackgroundImage: string;
  name: string;
  productImage: string;
  trackingName: string;
  trackingTier: number;
  user: User;
}
const PlusEssentialsPhase1Ad = ({
  backgroundImage,
  campaignEndDate,
  couponCode,
  dollarAmountSaved,
  link,
  name,
  productImage,
  mobileBackgroundImage,
  trackingName,
  trackingTier,
  user
}: PlusEssentialsPhase1AdProps) => {
  return <a href={link} className={trackingName} id={`${trackingName}-tier${trackingTier}`} data-testid="homepage-plus-essentials-ad" data-sentry-component="PlusEssentialsPhase1Ad" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx">
      <div className="mx-auto mt-8 mb-2 relative overflow-hidden rounded bg-blue-50 border border-solid border-blue-300 flex flex-col xs:flex-row justify-between">
        <div className="relative z-10">
          <div className="p-6 pb-0 xs:pb-6 md:p-8 md:pb-8 lm:p-10 lm:pb-10">
            <div className="w-full xs:max-w-lg lm:max-w-2xl text-center xs:text-left flex flex-col items-center xs:items-start xs:whitespace-nowrap">
              <span className="uppercase text-sm leading-loose text-blue-900 font-semibold xl:text-base tracking-[.2rem]">
                Just for You, {user.firstName}!
              </span>
              <h3 data-testid="plus-essentials-headline" className="text-blue-900 font-bold text-2xl md:text-3xl lt:text-4xl xl:text-[46px] leading-none mb-2 mx-0">
                Get ${dollarAmountSaved} in FREE
                <span className="capitalize"> {name}</span>
              </h3>
              <p className="text-base xs:text-sm md:text-base font-semibold leading-tight text-blue-900 xl:mb-8">
                <span className="block xs:hidden lz:block">
                  Save instantly on select brands of {name} with no minimum
                  spend.
                </span>
                <span className="hidden xs:block lz:hidden">
                  Save instantly on select brands of {name} with
                  <br />
                  no minimum spend.
                </span>
              </p>
              <div className="flex flex-col xs:flex-row items-center gap-x-4">
                <span className="bg-blue-900 text-white font-bold px-6 xs:px-2 md:px-6 py-2 rounded text-xs sm:text-sm md:text-base">
                  Use Code: {couponCode}
                </span>
                <div className="flex flex-col mt-4 xs:mt-0">
                  <span className="text-sm font-bold text-blue-900">
                    Offer ends {campaignEndDate}
                  </span>
                  <span className="text-sm xs:text-xs sm:text-sm font-normal text-blue-900">
                    Limited Time, Single Use Code
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative w-full xs:w-1/3 lt:w-2/5 z-10 overflow-visible mt-0">
          <img className="block xs:hidden w-full" src={mobileBackgroundImage} alt="" />
          <span className="overflow-visible z-20 hidden xs:block absolute left-2 xs:left-0 md:left-8 xl:left-4 top-20 sm:top-24 md:top-[12px] w-24 xl:w-[126px]">
            <LargePlusLogo data-sentry-element="LargePlusLogo" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx" />
          </span>
          <span className="overflow-hidden z-20 hidden md:block absolute w-28 xl:w-36 h-28 xl:h-36 left-0 top-[70px] xl:top-[84px]">
            <img className="" src={productImage} alt="" />
          </span>
          <svg className="z-10 absolute hidden md:block inset-y-0 left-0 right-0 h-full w-16 md:w-28 fill-blue-50" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-sentry-element="svg" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx">
            <polygon points="0,0 90,0 50,100 0,100" data-sentry-element="polygon" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx" />
          </svg>
          <svg className="z-10 absolute hidden xs:block md:hidden inset-y-0 left-0 right-0 h-full w-[80px] md:w-28 fill-blue-50" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true" data-sentry-element="svg" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx">
            <polygon points="0,0 100,0 10,100 0,100" data-sentry-element="polygon" data-sentry-source-file="PlusEssentialsPhase1Ad.tsx" />
          </svg>
          <img className="absolute z-0 hidden xs:block aspect-auto object-cover h-full w-full" src={backgroundImage} alt="" />
        </div>
        <img className="absolute block xs:hidden z-0 w-full" src="https://www.webstaurantstore.com/uploads/design/2023/6/plus-ad_doodles-mobile.svg" alt="" />
        <img className="absolute hidden xs:block z-0 right-1/3 lt:right-1/2 h-full" src="https://www.webstaurantstore.com/uploads/design/2023/6/plus-ad_doodles.svg" alt="" />
      </div>
    </a>;
};
export default PlusEssentialsPhase1Ad;